import { generators, converters } from "@/_shared/utils";

export const useImageField = {
  data() {
    return {
      image: null,
      previewImage: null,
    };
  },
  methods: {
    checkPreviewImageExistence() {
      if (!this.form.image_name) {
        return;
      }
      const subfolderName = this.fallbackLink.substring(1);
      const url = `${process.env.MEDIA_URL}/static/${subfolderName}/${this.form.image_name}`;
      this.previewImage = url;
    },
    setImage(file) {
      this.image = file;
      this.previewImage = URL.createObjectURL(file);

      const uniqueSalt = generators.generateRandomString();
      this.form.image_name = `${uniqueSalt}-${this.image.name}`;
    },
    deleteImage() {
      this.previewImage = null;
      this.image = null;
      this.form.image_name = '';
    },
    async prepareImage(imageIsRequired = true) {
      if (!this.form.image_name && imageIsRequired) {
        throw new Error('Вы не добавили изображения для этой записи');
      }
      if (this.image !== null) {
        const convertedImage = await converters.toBase64(this.image);
        return convertedImage;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useImageField.js